import { BarChart } from "@jana-technology/platform-ui";

import { ChartCard, NetMitigatedRisk, PaginatedChart } from "components/charts";
import { MitigationRiskComparison } from "components/charts/RiskComparison";
import { useGlobalFiltersContext } from "contexts/filters";
import { xAccessor } from "helpers/charts";
import { useMitigationRiskCharts } from "hooks/queries";
import { useBaseBarChartProps } from "hooks/useBaseBarChartProps";
import { ChartsLayout } from "layouts/ChartsLayout";

export const RiskManagementMitigationRiskCharts = () => {
  const { appliedWell, appliedRiskMitigationId } = useGlobalFiltersContext();

  const [hierarchyId, wellName] = appliedWell;

  const {
    mitigationRiskByThreatSeries,
    mitigationRiskByConsequenceSeries,
    mitigationRiskByOutcomeScenarioSeries,
    mitigationRiskDataKeys,
    overallRiskChartsQueryResult,
  } = useMitigationRiskCharts({
    skip: !wellName.length,
    variables: {
      hierarchyId,
      wellName,
      riskMitigationTypeId: appliedRiskMitigationId,
    },
  });

  const baseBarChartProps = useBaseBarChartProps();

  return (
    <ChartsLayout>
      <NetMitigatedRisk />
      <ChartCard
        loading={overallRiskChartsQueryResult.loading}
        heading="Risk by Threat"
      >
        <BarChart
          {...baseBarChartProps}
          withBarLabels
          xAxisLabel="Threat"
          yAxisLabel="Threat Risk"
          xPadding={0.2}
          chartName="Risk by Threat"
          xAccessor={xAccessor}
          data={mitigationRiskByThreatSeries}
          dataKeys={mitigationRiskDataKeys}
        />
      </ChartCard>
      <ChartCard
        loading={overallRiskChartsQueryResult.loading}
        heading="Risk by Consequence"
      >
        <BarChart
          {...baseBarChartProps}
          withBarLabels
          xAxisLabel="Consequence"
          yAxisLabel="Overall Risk"
          chartName="Risk by Consequence"
          xAccessor={xAccessor}
          data={mitigationRiskByConsequenceSeries}
          dataKeys={mitigationRiskDataKeys}
        />
      </ChartCard>
      <ChartCard
        loading={overallRiskChartsQueryResult.loading}
        heading="Risk by Outcome Scenario"
      >
        <PaginatedChart data={mitigationRiskByOutcomeScenarioSeries}>
          <BarChart
            {...baseBarChartProps}
            withBarLabels
            xAxisLabel="Outcome Scenario"
            yAxisLabel="Overall Risk"
            chartName="Risk by Outcome Scenario"
            xAccessor={xAccessor}
            data={mitigationRiskByOutcomeScenarioSeries}
            dataKeys={mitigationRiskDataKeys}
          />
        </PaginatedChart>
      </ChartCard>
      <MitigationRiskComparison />
    </ChartsLayout>
  );
};

export default RiskManagementMitigationRiskCharts;
